import { createSelector } from '@reduxjs/toolkit';
import { employeesForStaffingCalendar } from './employees-for-staffing-calendar';
import { currentEmployeeUuid } from '../employees/current-employee-uuid';
import { holidaysForStaffingCalendar } from './holidays-for-staffing-calendar';
import { timekeepingPeriods } from './timekeeping-periods';

export const timekeepingPeriodsForCurrentEmployee = createSelector(
  employeesForStaffingCalendar,
  currentEmployeeUuid,
  holidaysForStaffingCalendar,
  function (employees, employeeUuid, holidays) {
    if (employees && employeeUuid) {
      return timekeepingPeriods(employees, employeeUuid, holidays);
    }
    return [];
  },
);
